<div class="py-2 px-2 py-md-5 px-md-5">
    <div class="row">
        <div class="col-md-8">
            <app-service-orders-list [isArchive]="true" [isInvoice]="false"></app-service-orders-list>
        </div>
    </div>
</div>
